var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D1D1D1",
    d: "M20.1924 18.7074L16.2343 14.7493C17.1872 13.4807 17.7017 11.9366 17.6999 10.35C17.6999 6.29722 14.4027 3 10.35 3C6.29722 3 3 6.29722 3 10.35C3 14.4027 6.29722 17.6999 10.35 17.6999C11.9366 17.7017 13.4807 17.1872 14.7493 16.2343L18.7074 20.1924C18.9078 20.3715 19.1691 20.4671 19.4377 20.4596C19.7064 20.4521 19.9619 20.342 20.152 20.152C20.342 19.9619 20.4521 19.7064 20.4596 19.4377C20.4671 19.1691 20.3715 18.9078 20.1924 18.7074ZM5.09999 10.35C5.09999 9.31161 5.40789 8.29659 5.98477 7.43323C6.56164 6.56988 7.38158 5.89698 8.34088 5.49962C9.30019 5.10226 10.3558 4.99829 11.3742 5.20087C12.3926 5.40344 13.328 5.90345 14.0623 6.63767C14.7965 7.37189 15.2965 8.30735 15.4991 9.32574C15.7016 10.3441 15.5977 11.3997 15.2003 12.359C14.8029 13.3183 14.13 14.1383 13.2667 14.7152C12.4033 15.292 11.3883 15.5999 10.35 15.5999C8.95809 15.5983 7.62371 15.0446 6.63951 14.0604C5.65532 13.0762 5.10166 11.7418 5.09999 10.35Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.7a346407.svg";
export { ForwardRef as ReactComponent };